<div *ngIf="!creating && publicPanelData[panelData.id]" class="text-panel alignRow alignColumn">
    <span class="text-panel-title alignColumn">
        {{!publicPanelData[panelData.id] ? 'Loading...' : panelData.title || panelData.nodeData.Name}}
    </span>
    <div class="text-panel-content">
        <div class="text-panel-metric"
            *ngFor="let x of [].constructor(publicPanelData[panelData.id] ? publicPanelData[panelData.id].numMetrics : 0); let idx = index">
            <span>{{publicPanelData[panelData.id] ? publicPanelData[panelData.id].metricLabels[idx] : ""}}:</span>
            <span>{{publicPanelData[panelData.id] ? publicPanelData[panelData.id].numberMetrics[idx] :
                ""}}{{publicPanelData[panelData.id] ? publicPanelData[panelData.id].SI : ""}}</span>
        </div>
    </div>
</div>

<div *ngIf="creating && panelData" class="text-panel alignRow alignColumn">
    <div class="text-panel-title alignRow">
        <span>{{(panelData.title || panelData.nodeData.Name) ?? 'Add Node'}} </span>
        <mat-icon [matMenuTriggerFor]="titleMenu" [matMenuTriggerData]="{panelData: panelData}">edit</mat-icon>
    </div>
    <div class="text-panel-content">
        <div class="text-panel-metric" *ngFor="let metric of panelData.metricData.metricChoices">
            <span>{{panelData.metricData.metrics[metric].text}}:</span>
            <span>0</span>
        </div>
    </div>
</div>

<div *ngIf="creating && !panelData" class="text-panel alignRow alignColumn">
    <div class="text-panel-title alignRow">
        <span>Text Panel</span>
    </div>
    <div class="text-panel-content">
        <div class="text-panel-metric">
            <span>Example Metric 1:</span>
            <span>2.56</span>
        </div>
        <div class="text-panel-metric">
            <span>Example Metric 2:</span>
            <span>4.84</span>
        </div>
    </div>
</div>

<div *ngIf="!creating && !publicPanelData[panelData.id]" class="spinner alignColumn">
    <img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/circle-lines.gif">
</div>